import { DisplayUnitsAction, DisplayUnitsState } from './types';

export default function displayUnitsReducer(
  state: DisplayUnitsState,
  action: DisplayUnitsAction,
): DisplayUnitsState {
  switch (action.type) {
    case 'DISPLAY_UNITS_FILTER': {
      const { defaultNumberOfUnits, maxNumberOfUnits } = action.payload;
      return { defaultNumberOfUnits, maxNumberOfUnits };
    }

    default:
      throw new Error(`Unhandled action type ${action?.type}`);
  }
}
